var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChartStackedBars, ChartLineIndependent } from "../svg-elements/module";
import { GraphControllerV2 } from "./graph-v2";
import { filterWeeks, getNeededColumnsForHistoryV2 } from "../d3-services/data-with-history.functions";
import * as d3 from "d3";
import HtmlLegendDotsLines from "../html-elements/html-legend-dots-lines";
var StackedBars = /** @class */ (function (_super) {
    __extends(StackedBars, _super);
    function StackedBars(main, data, element, mapping, segment) {
        var _this = _super.call(this, main, data, element, mapping, segment) || this;
        _this.main = main;
        _this.data = data;
        _this.element = element;
        _this.mapping = mapping;
        _this.segment = segment;
        _this.pre();
        return _this;
    }
    StackedBars.prototype.pre = function () {
        this._addScale('x', 'linear', 'horizontal', '_index');
        this._addScale('y', 'linear', 'vertical', 'immateriele_schade_nieuw_besluiten');
        this._addScale('y2', 'linear', 'vertical', 'percentage');
        this._addAxis('x', 'x', 'bottom', 'weekly');
        this._addAxis('y', 'y', 'left');
        this._addAxis('y2', 'y2', 'right');
        this._addMargin(0, 0, 0, 30);
        this._addPadding(30, 30, 30, 0);
    };
    StackedBars.prototype.init = function () {
        _super.prototype._init.call(this);
        var svgId = "svg-wrapper-" + this.mapping.slug;
        var container = document.createElement('section');
        container.style.height = "320px";
        container.style.width = "100%";
        container.id = svgId;
        this.element.appendChild(container);
        _super.prototype._svg.call(this, container);
        this.chartStackedBars = new ChartStackedBars(this);
        this.chartLine = new ChartLineIndependent(this, 'y2', 'black');
        this.legend = new HtmlLegendDotsLines(this);
        this.update(this.data, "all", false);
    };
    StackedBars.prototype.prepareData = function (data) {
        var _this = this;
        var neededColumns = getNeededColumnsForHistoryV2(data, this.mapping).concat(['immateriele_schade_toegewezen', 'immateriele_schade_besluiten']);
        var history = filterWeeks(data, neededColumns).reverse();
        history = history.filter(function (w) { return w[_this.parameters['y']] > 0; });
        history.forEach(function (week, i) {
            week['_index'] = i;
            week['percentage'] = (week['immateriele_schade_toegewezen'] / week['immateriele_schade_besluiten']) * 100;
        });
        this.keys = Object.keys(history[0]).filter(function (key) {
            return [_this.mapping.parameters[0][0].column, _this.mapping.parameters[0][1].column].indexOf(key) > -1;
        });
        this.stack = d3.stack()
            .keys(this.keys);
        return {
            "history": history,
            "latest": null,
            "slice": history,
            "stacked": this.stack(history)
        };
    };
    StackedBars.prototype.draw = function (data) {
        var _this = this;
        var xValues = data.slice.map(function (d) { return d[_this.parameters['x']]; });
        this.scales['x'].set([xValues[xValues.length - 1] + 1], xValues[0]);
        this.chartStackedBars.draw(data.stacked);
        this.chartLine.draw(data);
    };
    StackedBars.prototype.redraw = function (data) {
        this.scales['y'].set(Object.values(data.stacked[data.stacked.length - 1]).map(function (d) { return d[1] * 1.2; }));
        this.scales['y2'].set(data.slice.map(function (w) { return w['percentage']; }));
        _super.prototype.redraw.call(this, data);
        this.chartStackedBars.redraw(data.stacked);
        this.chartLine.redraw();
    };
    StackedBars.prototype.update = function (data, segment, update) {
        _super.prototype._update.call(this, data, segment, update);
    };
    return StackedBars;
}(GraphControllerV2));
export default StackedBars;
